// Helpers
function intersperse(arr, separator) {
  return arr.reduce((acc, curr) => [...acc, curr, separator], []).slice(0, -1)
}

function hasSourceActiveItem(sourceId, state) {
  return Boolean(
    state.collections.find(
      (collection) => collection.source.sourceId === sourceId && collection.items.find((item) => item.__autocomplete_id === state.activeItemId)
    )
  )
}

// Hooks
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions
      const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000
      const isOnSale = item.compare_at_price > item.price
      const isNewArrival = new Date(item.created_at) >= new Date(Date.now() - THIRTY_DAYS_MS)

      return html`
        <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img src="${algoliaShopify.helpers.compactImage(item)}" alt="${item.title}" />
              <div class="aa-ItemBadges">
                ${isNewArrival && html`<span class="aa-Badge aa-Badge--new">New Arrival</span>`}
                ${isOnSale && html`<span class="aa-Badge aa-Badge--sale">Sale</span>`}
              </div>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">${item.vendor && components.Highlight({ hit: item, attribute: 'vendor' })}</div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                  <span class="algolia-variant"> ${algoliaShopify.helpers.variantTitleAddition(item, distinct)} </span>
                </div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">${algoliaShopify.helpers.displayPrice(item, distinct)}</div>
                ${isOnSale &&
                html` <div class="aa-ItemContentPriceDiscounted">${algoliaShopify.helpers.displayStrikedPrice(item.price, item.compare_at_price)}</div> `}
              </div>
            </div>
          </div>
        </a>
      `
    }
  )

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
    const { searchClient } = window.algoliaShopify
    const { getAlgoliaResults } = window.algoliaShopify.externals

    const { createLocalStorageRecentSearchesPlugin } = window['@algolia/autocomplete-plugin-recent-searches']

    const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
      key: 'RECENT_SEARCH',
      limit: 3
    })

    const quickAccessPlugin = {
      name: 'custom-quick-access-plugin',
      getSources({ query }) {
        if (query) {
          return []
        }

        return [
          {
            sourceId: 'quickAccessPlugin',
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: 'shopify_products',
                    query,
                    params: {
                      hitsPerPage: 0,
                      ruleContexts: ['quickAccess']
                    }
                  }
                ],
                transformResponse({ results }) {
                  return results?.[0]?.userData?.[0]?.items || []
                }
              })
            },
            templates: {
              header({ html }) {
                return html` <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">What's On</span>
                </div>`
              },
              item({ item, html }) {
                return html`
                  <a href="${item.href}" class="aa-ItemLink aa-QuickAccessItem aa-QuickAccessItem--${item.template}">
                    <div class="aa-ItemContent">
                      ${item.image ? html`<div class="aa-ItemPicture"><img src="${item.image}" alt="${item.title}" /></div>` : ''}
                      <div class="aa-ItemContentBody" style="${item.bgColor ? `background-color: ${item.bgColor};` : ''}">
                        ${item.date ? html`<div class="aa-ItemContentDate">${item.date}</div>` : ''}
                        <div class="aa-ItemContentTitle">${html`${intersperse(item.title.split('\n'), html`<br />`)}`}</div>
                        ${item.subtitle ? html`<div class="aa-ItemContentSubTitle">${html`${intersperse(item.subtitle.split('\n'), html`<br />`)}`}</div>` : ''}
                        ${item.links && item.links.length
                          ? html`<ul>
                              ${item.links.map((link) => html`<li><a href="${link.href}">${link.text}</a></li>`)}
                            </ul>`
                          : ''}
                      </div>
                    </div>
                  </a>
                `
              }
            }
          }
        ]
      }
    }

    options.placeholder = 'Search for products or dietary requirements'
    options.openOnFocus = true
    options.detachedMediaQuery = 'none'

    if (!window.setAlgoliaAutocompleteOpen) {
      options.onStateChange = function ({ setIsOpen }) {
        window.setAlgoliaAutocompleteOpen = setIsOpen
      }
    }

    options.plugins.push(recentSearchesPlugin)
    options.plugins.push(quickAccessPlugin)

    return options
  })

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function (_defaultTemplate, templateOptions, elements) {
    const { html, state } = templateOptions

    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${!state.query &&
            elements.recentSearchesPlugin &&
            html` <div class="aa-PanelSection--recent">
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle">Recent Searches</span>
              </div>
              ${elements.recentSearchesPlugin}
            </div>`}
            ${!state.query
              ? html`
                  <div class="aa-PanelSection--popular">
                    <div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle">Popular Searches</span>
                    </div>
                    ${elements.querySuggestionsPlugin}
                  </div>
                `
              : html` ${elements.recentSearchesPlugin} ${elements.querySuggestionsPlugin} ${elements.collections} ${elements.articles} ${elements.pages}
                ${elements.redirectUrlPlugin}`}
          </div>
          <div class="aa-PanelSection--right">
            ${!state.query
              ? html` <div
                  class="aa-PanelSection--quickAccess aa-PanelSection--zoomable 
                ${hasSourceActiveItem('quickAccessPlugin', state) ? 'aa-PanelSection--active' : ''}"
                >
                  ${elements.quickAccessPlugin}
                </div>`
              : elements.products}
          </div>
        </div>
      </div>
    `
  })

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250)
    console.log({ hit })
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
        <img class="ais-hit--picture" src="${hitImage.src}" srcset="${hitImage.srcset}" sizes="${hitImage.sizes}" alt="${hit.title} - ${hit.variant_title}" />

        <div class="ais-hit--details">
          <p class="ais-hit--subtitle" title="${hit.product_type}${algoliaShopify.translation_helpers.by(hit.vendor)}">
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>

          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
            >
              ${components.Highlight({ attribute: 'title', hit })} ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>

          <p class="ais-hit--price">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
            ${!hit._distinct &&
            html` <span class="ais-hit--price-striked"><span>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span></span> `}
            ${!hit._distinct &&
            html` <span class="ais-hit--price-discount">${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}</span> `}
          </p>
          <p class="ais-hit--tags absolute top-2.5 left-2.5 flex flex-col items-center justify-center gap-1.5">
            ${hit?.tags?.map((tag) => {
              const tagIcon = SLS_STATE.tagIcons.find((t) => t.tag === tag)
              if (!tagIcon) return ''

              return html`
                <div class="relative flex flex-col items-center justify-center group [&:nth-child(n+7)]:hidden" title=${tag}>
                  <img
                    src="${tagIcon.icon}"
                    class="object-contain w-5 h-5 rounded-full pointer-events-none"
                    alt="${tag}"
                    loading="lazy"
                    width="36"
                    height="36"
                    style="background-color: ${tagIcon.background_color}"
                  />
                  <span
                    class="tooltip invisible group-hover:visible min-w-[105px] w-fit bg-ghost-white whitespace-nowrap border-default border border-solid text-grey-900 text-center text-label font-normal rounded absolute z-[1] -top-[8px] left-[calc(100%_+_68px)] -translate-x-1/2 after:content-[''] after:absolute after:bottom-[100%] after:left-0 after:-ml-[6px] after:border after:border-solid after:border-[#E7E7E7_transparent_transparent_#E7E7E7] after:w-3 after:h-3 after:-rotate-45 after:top-[10px] after:bg-ghost-white"
                  >
                    ${tag}
                  </span>
                </div>
              `
            })}
          </p>
          ${!hit._distinct &&
          html`
            <form id="algolia-add-to-cart-${hit.objectID}" style="display: none;" action="/cart/add" method="post" enctype="multipart/form-data">
              <input type="hidden" name="id" value="${hit.objectID}" />
            </form>
            <p class="ais-hit--cart">
              ${hit.can_order
                ? html`
                    <button class="ais-hit--cart-button" data-form-id="algolia-add-to-cart-${hit.objectID}">${algoliaShopify.translations.addToCart}</button>
                  `
                : html` <button class="ais-hit--cart-button ais-hit--cart-button__disabled">${algoliaShopify.translations.outOfStock}</button> `}
            </p>
          `}
        </div>
      </div>
    `
  })
})

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">${algoliaShopify.translations.showFilters}</div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            (facet) =>
              html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                  <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
                  <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html` ${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance} `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `
  })
})

// const tagIcons = {
//   "Vegan": '<img src="/icons/vegan.svg" alt="Vegan icon" class="tag-icon" />',
//   "Organic": '<img src="/icons/organic.svg" alt="Organic icon" class="tag-icon" />',
//   "Sale": '<img src="/icons/sale.svg" alt="Sale icon" class="tag-icon" />',
// };

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
    if (facet.title === 'Tags') {
      return {
        ...params,
        transformItems(items) {
          return items.map((item) => {
            const tagIcon = SLS_STATE.tagIcons.find((t) => t.tag === item.label)
            return {
              ...item,
              icon: tagIcon?.icon || null,
              bgColor: tagIcon?.background_color || null
            }
          })
        },
        templates: {
          item(item, { html, refine }) {
            return html`
              <li class="ais-RefinementList-item ais-facet--item ${item.isRefined ? 'ais-RefinementList-item--selected' : ''}">
                <label class="ais-RefinementList-label ais-facet--label flex items-center cursor-pointer" onclick="${() => refine(item.value)}">
                  <input
                    type="checkbox"
                    class="ais-RefinementList-checkbox ais-facet--checkbox"
                    ${item.isRefined ? 'checked' : ''}
                    onclick="event.stopPropagation()"
                  />
                  ${item.icon
                    ? html` <img
                        src="${item.icon}"
                        alt="${item.label}"
                        class="object-contain w-5 h-5 rounded-full pointer-events-none mr-1"
                        style="background-color: ${item.bgColor};"
                      />`
                    : ''}
                  <span class="ais-RefinementList-labelText">${item.label}</span>
                  <span class="ais-RefinementList-count ais-facet--count-distinct">${item.count}</span>
                </label>
              </li>
            `
          },
          searchableNoResults(data, { html }) {
            return html`<span>No results</span>`
          }
        }
      }
    }

    return {
      ...params
    }
  })
})

// document.addEventListener("scroll", function () {
//   if (window.innerWidth > 768 && typeof window.setAlgoliaAutocompleteOpen === "function") {
//     window.setAlgoliaAutocompleteOpen(false);
//   }
// }, { passive: true });
